// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3MEoW","buttons":"PendingPaymentAlert_buttons__2F1z8"};